import {
  CreateSubscriptionSettingsInfo,
  SubscriptionSettings,
} from '../../../../interfaces/subscriptionSettings';
import { CreateSubscriptionFormValues } from '../../../../interfaces/createSubscription';
import { BILLING_PERIOD_TYPE } from '../../../../constants/billingPeriodType';

export const defaultFormValue: CreateSubscriptionFormValues = {
  name: '',
  subscriptionType: '',
  billingPeriodType: BILLING_PERIOD_TYPE.MONTHLY,
  subscriptionPrice: {
    initialPlanPrice: '',
    initialPlanDuration: '',
    initialPlanUserFee: '',
    initialPlanOneTimeFee: '',
    monthlyRenewalPrice: '',
    monthlyRenewalFees: '',
  },
} as any as CreateSubscriptionFormValues;

export const processFormDefaultValues = (
  subscriptionSettings?: SubscriptionSettings | CreateSubscriptionSettingsInfo | null,
): CreateSubscriptionFormValues => {
  if (!subscriptionSettings) {
    return defaultFormValue;
  }

  const { name, subscriptionType, billingPeriodType, subscriptionPrice } =
    defaultFormValue;
  const { initialPlanFees, onboardingFees, renewalFees } = subscriptionSettings;

  return {
    name,
    subscriptionType,
    billingPeriodType,
    subscriptionPrice: {
      ...subscriptionPrice,
      initialPlanUserFee: initialPlanFees,
      initialPlanOneTimeFee: onboardingFees,
      monthlyRenewalFees: renewalFees,
    },
  };
};
